import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useReviewsContext } from "@/components/Product/Reviews/context/reviews.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export const SelectedFilters = () => {
    const { t } = useGranite();
    const { ratings, toggleRating, locales, toggleLocale, clearFilters } =
        useReviewsContext();

    const selectedFilters = [
        ...ratings.map((rating) => ({
            label: t("product.reviews.summary.starFilter.stars", rating),
            clear: () => toggleRating(rating)
        })),
        ...locales.map((locale) => ({
            label: t(`general.language.${locale}`),
            clear: () => toggleLocale(locale)
        }))
    ];

    return (
        <>
            {selectedFilters.map((selectedFilter) => (
                <Button
                    key={selectedFilter.label}
                    className={cn("tw:mr-2 tw:mt-2")}
                    color={"gray"}
                    size="sm"
                    onClick={selectedFilter.clear}
                    type={"button"}
                >
                    {selectedFilter.label}
                    <i className={cn("las la-times", "tw:ml-2")}></i>
                </Button>
            ))}
            {selectedFilters.length > 1 && (
                <Button
                    className={cn("tw:mt-2 tw:bg-transparent tw:text-primary")}
                    type="button"
                    color="primary"
                    size="sm"
                    outline={true}
                    onClick={clearFilters}
                >
                    {t("search.selectedRefinements.clear")}
                </Button>
            )}
        </>
    );
};
